import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import { SITE } from "@/lib/site";

export default function HomeHero() {
  return (
    <section className="relative bg-br-black text-white overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1503594384566-461fe158e797?w=1800&q=80" alt="Austin home exterior with new construction" className="w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
      </div>
      <div className="relative container-br grid lg:grid-cols-12 gap-10 py-12 lg:py-20">
        <div className="lg:col-span-7 fade-up">
          <div className="br-eyebrow">Austin & Central Texas — Full-Service GC</div>
          <h1 className="br-headline text-4xl sm:text-5xl lg:text-6xl mt-4">
            Austin's Full-Service Construction, Roofing &amp; Home Maintenance Partner
          </h1>
          <p className="mt-5 text-gray-200 max-w-2xl text-base sm:text-lg leading-relaxed">
            From roof repairs and remodels to ongoing property maintenance, Black Ridge Construction helps homeowners protect, improve, and upgrade their homes with one trusted team.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/contact" className="br-btn-primary" data-testid="hero-cta-primary">Request a Consultation <ArrowRight size={14}/></Link>
            <Link to="/maintenance-plans" className="br-btn-secondary" data-testid="hero-cta-secondary">View Maintenance Plans</Link>
            <Link to="/subcontractor-partnerships" className="br-btn-secondary">Partner With Us</Link>
          </div>
          <div className="mt-7 flex flex-wrap items-center gap-5 text-sm text-gray-300">
            <a href={`tel:${SITE.phoneE164}`} className="flex items-center gap-2 hover:text-br-bronze-2"><Phone size={14}/> {SITE.phone}</a>
            <div className="flex items-center gap-2"><ShieldCheck size={14} className="text-br-bronze-2"/> Locally focused Austin contractor</div>
            <div className="flex items-center gap-2"><Sparkles size={14} className="text-br-bronze-2"/> One team. Many trades.</div>
          </div>
        </div>
        <div className="lg:col-span-5 fade-up d-2">
          <div className="bg-white rounded-md shadow-2xl p-6 sm:p-7" data-testid="hero-form-card">
            <ContactForm title="Request a Consultation" source_page="home" />
          </div>
        </div>
      </div>
    </section>
  );
}
